import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { FoodCart, FoodCartItem, FoodCartRequest, StoreMetaInfo } from '../../models/cart-models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HelperService } from '../helper/helper.service';
import { EnvironmentConfigService } from '../shared/environment-config.service';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class RetailCartService {

  storeMetaInfo: StoreMetaInfo;
  apiConfig = {
    baseUrl: 'https://api2.travelx.ai',
    updateCartStatePath: '/api/updateCartState',
    getCartListPath: '/api/getCartList',
    checkoutCartPath: '/api/checkoutcart'
  };

  apiParams: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private httpClient: HttpClient, private helperService: HelperService, private envService: EnvironmentConfigService) {
    this.initApiParams();
    this.getCartList();
  }

  initApiParams() {
    this.apiParams = {
      novalidation: 1,
      ptype: 'retail',
    };
  }

  public set guestId(value: string) {
    localStorage.setItem('guestId', value);
  }

  public get guestId(): string {
    return localStorage.getItem('guestId');
  }

  public set guestDeviceId(value: string) {
    localStorage.setItem('guestDeviceId', value);
  }

  public get guestDeviceId(): string {
    return localStorage.getItem('guestDeviceId');
  }

  public get cartStateApi(): string {
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.cartStateApi = `${this.envService.updateCartStateApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }

  public set cartStateApi(value: string) {
  }

  public get getCartListApi(): string {
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.getCartListApi = `${this.envService.getCartListApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }

  public get getFinalPriceApi(): string {
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.getCartListApi = `${this.envService.getFinalPriceApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }

  public set getCartListApi(value: string) {
  }


  public get checkoutCartApi(): string {
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.checkoutCartApi = `${this.envService.checkoutRetailCartApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }

  public set checkoutCartApi(value: string) {
  }

  public addProductToCart(item: any, storeId: number, locationId: number) {

    if (this.guestId !== null) {
      this.apiParams.isfirst = 0;
      this.apiParams.guestid = this.guestId;
    } else if (localStorage.getItem('userId') == null) {
      this.apiParams.isfirst = 1;
    }
    if (this.guestDeviceId !== null) {
      this.apiParams.deviceid = this.guestDeviceId;
    }

    this.apiParams.storeid = storeId;
    // this.apiParams.deviceid = this.guestDeviceId;
    // this.apiParams.platformid = this.guestDeviceId;
    // this.apiParams.guestid = this.guestId;
    this.apiParams.location_id = locationId;
    this.apiParams.productid = item.id;
    this.apiParams.quantity = item.quantity + 1;
    this.apiParams.ptype = 'retail';
    this.apiParams.clearCart = 0;

    return this.httpClient.get<any>(this.cartStateApi)
      .pipe(
        map(response => {
          if (response.status) {
            // ('response recieved', response.status);
            if (this.guestId == null && localStorage.getItem('userId') == null) {
              this.guestId = response.guestId;
            }
            if (this.guestDeviceId == null) {
              this.guestDeviceId = response.guestDeviceId;
            }
          }
          return response;
        })
      );


  }

  public getCartList() {
    if (this.guestId !== null) {
      this.apiParams.guestid = this.guestId;
    }
    if (this.guestDeviceId !== null) {
      this.apiParams.deviceid = this.guestDeviceId;
    }
    // this.apiParams.airport = this.airportService.getSelectedAirport();
    return this.httpClient.get<any>(this.getCartListApi);
  }

  public getFinalPrice(postData) {
    let post_data = postData;
    return this.httpClient.post<any>(this.getFinalPriceApi, post_data, this.httpOptions);
  }

  public removeCartItemById(item: any) {


    this.apiParams.storeid = item.storeId;
    if (this.guestId !== null) {
      this.apiParams.guestid = this.guestId;
    }
    if (this.guestDeviceId !== null) {
      this.apiParams.deviceid = this.guestDeviceId;
      this.apiParams.platformid = this.guestDeviceId;
    }

    this.apiParams.location_id = item.locationId;
    this.apiParams.productid = item.id;
    this.apiParams.quantity = item.quantity - 1;
    this.apiParams.ptype = 'retail';
    this.apiParams.clearCart = 0;

    return this.httpClient.get<any>(this.cartStateApi);

  }

  checkoutCart(userInfo, retailCart, autoCheckoutData?: any) {
    this.apiParams.location_id = retailCart[0].locationId;
    // this.apiParams.airportid = '';
    let cartIds = '';
    let postData = {
      user: {},
      ACFResp: {} as any
    };
    retailCart.forEach((item) => {
      cartIds = cartIds + ',' + item.cartId;
    });
    this.apiParams.cartids = cartIds;
    this.apiParams.name = userInfo.Name;
    this.apiParams.email = userInfo.Email;
    this.apiParams.phone = userInfo.number;
    this.apiParams.final_price = userInfo.finalPrice;
    this.apiParams.asp_case_id = userInfo.asp_case_id;
    this.apiParams.storeid = retailCart[0].storeId;
    if (this.guestId !== null) {
      this.apiParams.guestid = this.guestId;
    }
    if (this.guestDeviceId !== null) {
      this.apiParams.deviceid = this.guestDeviceId;
      this.apiParams.platformid = this.guestDeviceId;
    }
    if (autoCheckoutData) {
      postData.ACFResp = autoCheckoutData;
    }
    this.apiParams.version = 2;
    this.apiParams.type = 'retail';
    if (localStorage.getItem("pid") == "asp") {
      userInfo.flightId = localStorage.getItem("flight_id");
      userInfo.flight_date = localStorage.getItem("flight_date");
      userInfo.pickup_time = localStorage.getItem("pickup_time");
      postData.user = userInfo;
      this.apiParams.flightid = userInfo.flightId;
      this.apiParams.pickuptime = userInfo.flight_date + ' ' + userInfo.pickup_time;
    }
    return this.httpClient.post<any>(this.checkoutCartApi, postData, this.httpOptions);
  }

  public async clearCart() {
    this.apiParams.clearCart = 1;
    const response = await this.httpClient.get<any>(this.cartStateApi).toPromise();
    if (response.status) {
      return true;
    } else {
      return false;
    }

  }
}
